import { render } from "./supplierIndex.vue?vue&type=template&id=6f8a7e52&scoped=true"
import script from "./supplierIndex.vue?vue&type=script&lang=js"
export * from "./supplierIndex.vue?vue&type=script&lang=js"

import "./supplierIndex.vue?vue&type=style&index=0&id=6f8a7e52&scoped=true&lang=css"

import exportComponent from "E:\\edu-ui\\BmMuseumAdmin\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6f8a7e52"]])

export default __exports__